import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  CDK_TABLE,
  CDK_TABLE_TEMPLATE,
  CdkTable,
  STICKY_POSITIONING_LISTENER,
  _COALESCED_STYLE_SCHEDULER,
  _CoalescedStyleScheduler,
} from '@angular/cdk/table';
import {
  _DisposeViewRepeaterStrategy,
  _VIEW_REPEATER_STRATEGY,
} from '@angular/cdk/collections';

/**
 * Wrapper for the `CdkTable` with Closecare design styles.
 *
 * Inherits all orchestration (column projection, multiTemplateDataRows,
 * sticky positioning, trackBy, DataSource lifecycle, row outlets) from
 * `CdkTable`. Only the sticky CSS class and host styling differ.
 *
 * Visual rules for `.app-table`, `.app-row`, `.app-cell` etc. live in
 * `table.global.scss` (imported from `closecare-theme.scss`) so they can
 * reach projected content without `::ng-deep` or `ViewEncapsulation.None`.
 */
@Component({
  selector: 'app-table, table[app-table]',
  exportAs: 'appTable',
  template: CDK_TABLE_TEMPLATE,
  host: {
    class: 'app-table',
    '[class.app-table-fixed-layout]': 'fixedLayout',
    ngSkipHydration: '',
  },
  providers: [
    {
      provide: _VIEW_REPEATER_STRATEGY,
      useClass: _DisposeViewRepeaterStrategy,
    },
    { provide: CdkTable, useExisting: AppTableComponent },
    { provide: CDK_TABLE, useExisting: AppTableComponent },
    { provide: _COALESCED_STYLE_SCHEDULER, useClass: _CoalescedStyleScheduler },
    { provide: STICKY_POSITIONING_LISTENER, useValue: null },
  ],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class AppTableComponent<T> extends CdkTable<T> {
  protected override stickyCssClass = 'app-table-sticky';
  protected override needsPositionStickyOnElement = false;
}
